// extracted by mini-css-extract-plugin
export var bodyRow = "_ci-d";
export var cardColumns = "_ci-e";
export var ellipsesOverflow = "_ci-2";
export var flatBottomCorners = "_ci-3";
export var flatTopCorners = "_ci-4";
export var headerActionsDropdown = "_ci-f";
export var headerBottomRow = "_ci-c";
export var headerTopRow = "_ci-b";
export var orderDetailsWrapper = "_ci-0";
export var orderInfoContainer = "_ci-1";
export var productDetails = "_ci-9";
export var productImage = "_ci-5";
export var responsiveTable = "_ci-8";
export var shipmentContainer = "_ci-a";
export var tableBottomLeft = "_ci-6";
export var tableBottomRight = "_ci-7";
export var trackingLink = "_ci-g";